import jsonMenu from "../components/Menu/Items.json"
import { checkPermissionUser } from "./permissions-functions"

export const renderServiceMenu = (dataPermissions) => {

    try {

        const menuPermissions = checkMenuPermissions(jsonMenu, dataPermissions)

        return menuPermissions

    } catch (error) {

        return jsonMenu
    }
}

const checkMenuPermissions = (arrayMenu, ArrayPermissions) => {

    try {

        for (let i = 1; i < arrayMenu.length; i++) {


            switch (arrayMenu[i].text) {
                // case "Transferencias":
                //     //console.log("ENTRO A TRANSFERS")
                //     if(checkPermissionUser(ArrayPermissions, 1) || checkPermissionUser(ArrayPermissions, 2)){
                //         arrayMenu[i].state = true
                //     }else{
                //         arrayMenu[i].state = false
                //     }
                //     break;
                case "Créditos":
                    //console.log("ENTRO A PAGO DE CREDITOS")
                    if (checkPermissionUser(ArrayPermissions, 3)) {
                        arrayMenu[i].state = true
                    } else {
                        arrayMenu[i].state = false
                    }
                    break;
                case "Certificados":
                    //console.log("ENTRO A CERTIFICADOS")
                    if (checkPermissionUser(ArrayPermissions, 22) || checkPermissionUser(ArrayPermissions, 17)) {
                        arrayMenu[i].state = true
                        arrayMenu[i].subItems = checkSubMenuPermissions(arrayMenu[i].subItems, ArrayPermissions)
                    } else {
                        arrayMenu[i].state = false
                    }
                    break;
                // case "Pago de Servicios":
                //     //console.log("ENTRO A PAGO DE SERVICIOS")
                //     if(checkPermissionUser(ArrayPermissions, 4)){
                //         arrayMenu[i].state = true
                //     }else{
                //         arrayMenu[i].state = false
                //     }
                //     break;
                case "Roles de Pago":
                    //console.log("ENTRO A ROLES DE PAGO")
                    if (checkPermissionUser(ArrayPermissions, 10) || checkPermissionUser(ArrayPermissions, 11) || checkPermissionUser(ArrayPermissions, 12)) {
                        arrayMenu[i].state = true
                        arrayMenu[i].subItems = checkSubMenuPermissions(arrayMenu[i].subItems, ArrayPermissions)
                    } else {
                        arrayMenu[i].state = false
                    }
                    break;
                case "Comprobantes":
                    //console.log("ENTRO A COMPROBANTES")
                    if (checkPermissionUser(ArrayPermissions, 19)) {
                        arrayMenu[i].state = true
                    } else {
                        arrayMenu[i].state = false
                    }
                    break;
                case "Ver cupos":
                    //console.log("ENTRO A CAMBIO DE CUPOS")
                    if (checkPermissionUser(ArrayPermissions, 5)) {
                        arrayMenu[i].state = true
                    } else {
                        arrayMenu[i].state = false
                    }
                    break;
                case "Donaciones":
                    //console.log("ENTRO A DONACIONES")
                    if (checkPermissionUser(ArrayPermissions, 23)) {
                        arrayMenu[i].state = true
                    } else {
                        arrayMenu[i].state = false
                    }
                    break;
                case "Transacciones":
                    /*if (!checkPermissionUser(ArrayPermissions, 4)) {
                        arrayMenu[i].subItems.pop()

                    }
                    else*/ if (checkPermissionUser(ArrayPermissions, 1)
                        || checkPermissionUser(ArrayPermissions, 2)
                        || checkPermissionUser(ArrayPermissions, 4)
                        || checkPermissionUser(ArrayPermissions, 25)
                        || checkPermissionUser(ArrayPermissions, 26)

                    ) {
                        arrayMenu[i].state = true // validar subitems
                        arrayMenu[i].subItems = checkSubMenuPermissions(arrayMenu[i].subItems, ArrayPermissions)
                    } else {
                        arrayMenu[i].state = false
                    }
                    break;
                default:
                    break;
            }
        }

        return arrayMenu
    } catch (error) {
        return arrayMenu
    }
}

const checkSubMenuPermissions = (arraySubMenu, ArrayPermissions) => {

    try {

        for (let i = 0; i < arraySubMenu.length; i++) {


            switch (arraySubMenu[i].sroute) {
                case "/certificates":
                    if (checkPermissionUser(ArrayPermissions, 22)) {
                        arraySubMenu[i].state = true
                    } else {
                        arraySubMenu[i].state = false
                    }
                    break;
                case "/consult-certificates":
                    if (checkPermissionUser(ArrayPermissions, 17)) {
                        arraySubMenu[i].state = true
                    } else {
                        arraySubMenu[i].state = false
                    }
                    break;
                case "/upload-pay-role":
                    if (checkPermissionUser(ArrayPermissions, 11)) {
                        arraySubMenu[i].state = true
                    } else {
                        arraySubMenu[i].state = false
                    }
                    break;
                case "/payment-pay-role":
                    if (checkPermissionUser(ArrayPermissions, 10)) {
                        arraySubMenu[i].state = true
                    } else {
                        arraySubMenu[i].state = false
                    }
                    break;
                case "/activities-pay-role":
                    if (checkPermissionUser(ArrayPermissions, 12)) {
                        arraySubMenu[i].state = true
                    } else {
                        arraySubMenu[i].state = false
                    }
                    break;
                case "/activities-transactions":
                    if (
                        checkPermissionUser(ArrayPermissions, 25) ||
                        checkPermissionUser(ArrayPermissions, 26
                        )) {
                        arraySubMenu[i].state = true
                    } else {
                        arraySubMenu[i].state = false
                    }
                    break;

                case "/transfers":
                    if (
                        checkPermissionUser(ArrayPermissions, 1) ||
                        checkPermissionUser(ArrayPermissions, 2

                        )) {
                        arraySubMenu[i].state = true
                    } else {
                        arraySubMenu[i].state = false
                    }
                    break;
                case "services-payment":

                    arraySubMenu[i].state = true
                    break;

                default:
                    break;
            }
        }
        return arraySubMenu

    } catch (error) {
        return arraySubMenu
    }
}